export default __webpack_public_path__ + "static/media/lead-score-old.e587d1db.svg";